import { useContext } from 'react';
import { CreditContext } from '../context/CreditProvider';

export const useCreditContext = () => {
  const context = useContext(CreditContext);
  return context;
};
